import { IconButton, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelUpload = ({ data, filename = 'export.xlsx' }) => {
  const handleExport = () => {
    // Map the data to only include specific fields shown in the table
    const filteredData = data.map((row, index) => ({
      'S.No': index + 1,
      'Project': row.Project,
      'Milestone': row.Milestone,
      'Operation Stage': row.OperationStage,
      'Activities': row.Activites,
      'Task Date': row.ScheduleDate,
      'Task Description': row.Task,
      'Scheduled To': row.ScheduledToName,
      'Status': row.Status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Tasks');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(file, filename);
  };

  return (
    <Tooltip title="Export to Excel">
      <IconButton onClick={handleExport}>
        <FileDownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ExcelUpload;

